import { H2 } from '@npco/zeller-design-system'
import styled from 'styled-components'

import { BREAKPOINT } from 'styles/breakpoints'
import { AsideLayout } from 'layouts/AsideLayout'

export const StyledDashboardLayoutContent = styled.div<{
  $isNewPageTemplateRoute?: boolean
}>`
  ${({ $isNewPageTemplateRoute }) =>
    !$isNewPageTemplateRoute &&
    `
      box-sizing: border-box;
      display: flex;
      flex-flow: column nowrap;
      margin: 0 auto;
      padding: 0 16px;
      position: relative;
      width: 100%;
      overflow: scroll;

      @media screen and (min-width: ${BREAKPOINT.XS}px) {
        padding: 0 20px;
      }

      @media screen and (min-width: ${BREAKPOINT.SM}px) {
        padding: 0 56px;
      }

      @media screen and (min-width: ${BREAKPOINT.MD}px) {
        padding: 0 64px;
      }

      @media screen and (min-width: ${BREAKPOINT.LG}px) {
        max-width: 1464px;
        padding: 0 76px;
      }
    `}

  height: 100%;
  overflow: scroll;
`

export const StyledTitle = styled(H2).attrs({
  'data-testid': 'dashboard-layout-title',
})`
  margin: 0;
  color: ${({ theme }) => theme.colors.BLACK};
`

export const StyledContainer = styled.span`
  & > a {
    color: ${({ theme }) => theme.colors.BLUE_1000};
    text-decoration: initial;
  }
`

export const StyledIconWrapper = styled.span`
  padding: 0 10px;
`

export const StyledMaxWidthContainer = styled.div`
  max-width: 1920px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  background: ${({ theme }) => theme.colors.WHITE};
`

export const StyledFullWidthBackgroundContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  background: #f0f0f0;
`

export const StyledAsideLayout = styled(AsideLayout)`
  width: 100%;
`
